import React from 'react';
import { Box } from '@mui/material';

function SecondPage() {
  return (
    <Box
      id="second-page"
      sx={{
        height: '100vh',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden', // Ensure no content spills outside
      }}
    >
      {/* Video Background */}
      <Box
        component="video"
        autoPlay
        loop
        muted
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      >
        <source src="/images/anima.webm" type="video/webm" />
        <source src="/images/anima.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </Box>
    </Box>
  );
}

export default SecondPage; 